export interface RCAppConfig {
  customer: {
    rsa: {
      termOptions: { label: string; value: number }[]
    }
  }
}

export const DEFAULT_CONFIG_RCAPP = {
  customer: {
    rsa: {
      termOptions: [{ label: '12 Months', value: 12 }],
    },
  },
} as RCAppConfig

export const DEFAULT_MINER_SN_THRESHOLD = 22
